import React from 'react';
import dateformat from 'dateformat';

import {defaultTheme} from '@ibibo/build-theme';
import {UPCOMING_KEY, CANCELLED_KEY, COMPLETED_KEY, FAILED_KEY} from '@ibibo/myaccount-reducer';

import * as S from './BookingCardInfoHead.styles';

import {
  StatusIconUpcoming,
  StatusIconCancelled,
  StatusIconCompleted,
  StatusIconFailed,
  StatusIconInProgress
} from '../StatusIcon/StatusIcon';

import IconSelector from '@ibibo/icon-selector';

import RupeeIcon from '../../../../../../../../hotels-dweb/src/stories/Icons/RupeeIcon';

const HotelName = ({hotel_name, rating}) => <>
  <S.HeaderMainText>{hotel_name}</S.HeaderMainText>
  {new Array(rating).fill(1).map((_, i) => (
    <S.StarWrapper key={i} >
      <IconSelector iconKey='ratingstar' />
    </S.StarWrapper>
  ))}
</>;

const UpcomingAndCompletedCard = ({data}) => {
  const {amount, booking_id, hotel_city, hotel_name, rating, status_text, trip_type} = data;

  const completed = (trip_type.toLowerCase() === COMPLETED_KEY);

  return (<S.TripInfoHeadInnerWrap>
    <S.TripInfoDetailMainWrap>
      <HotelName hotel_name={hotel_name} rating={rating} />
      {(status_text && <S.TripDaysWrap>{status_text}</S.TripDaysWrap>) || null}
    </S.TripInfoDetailMainWrap>
    <S.TripInfoSubDetailsWrap>
      {(completed && <>
        <S.CompletedInfo>Completed</S.CompletedInfo>
        <S.TripDetailDivider />
      </>) || null}
      <S.TripInfoMainText>Hotel in {hotel_city}</S.TripInfoMainText>
      <S.TripDetailDivider />
      <S.TripBookingDetail>Booking ID - {booking_id}</S.TripBookingDetail>
      <S.TripDetailDivider />
      <S.TripBookingDetail>
        <IconSelector iconKey='rupee' props={{width:"1rem", height:'1rem', fill:'#747474'}} />
        {amount.toLocaleString('en-IN')}
      </S.TripBookingDetail>
    </S.TripInfoSubDetailsWrap>
  </S.TripInfoHeadInnerWrap>);
};

const CancelledAndFailedCard = ({data}) => {
  const {amount, refund_amount, booking_id, hotel_city, hotel_name, rating, status_text, cancellation_time} = data;

  return (<S.TripInfoHeadInnerWrap>
    <S.TripInfoDetailMainWrap>
      <HotelName hotel_name={hotel_name} rating={rating} />
      {(status_text && <S.RefundStatus>{status_text}</S.RefundStatus>) || null}
    </S.TripInfoDetailMainWrap>
    <S.TripInfoSubDetailsWrap>
      {(cancellation_time && <>
        <S.CancelledInfo>Cancelled on {dateformat(new Date(cancellation_time), 'dd mmm')}</S.CancelledInfo>
        <S.TripDetailDivider />
      </>) || null}
      <S.TripInfoMainText>Hotel in {hotel_city}</S.TripInfoMainText>
      <S.TripDetailDivider />
      <S.TripBookingDetail>Booking ID - {booking_id}</S.TripBookingDetail>
      <S.TripDetailDivider />
      <S.TripBookingDetail>
        <RupeeIcon width="1rem" height="1rem" fill={defaultTheme.colors.grey.dark74} />
        {refund_amount ? `Refund of ${refund_amount.toLocaleString('en-IN')}` : amount.toLocaleString('en-IN')}
      </S.TripBookingDetail>
    </S.TripInfoSubDetailsWrap>
  </S.TripInfoHeadInnerWrap>);
};

const HotelCardInfoHead = ({data, navigateToMyTripsDetails}) => {
  const {trip_type, payment_id, mobile} = data;

  const HotelInfo = () => {
    switch(trip_type.toLowerCase()) {
      case UPCOMING_KEY:
        return <UpcomingAndCompletedCard data={data} />;
      case COMPLETED_KEY:
        return <UpcomingAndCompletedCard data={data} />;
      case CANCELLED_KEY:
        return <CancelledAndFailedCard data={data} />;
      case FAILED_KEY:
        return <CancelledAndFailedCard data={data} />;
      default:
        return <UpcomingAndCompletedCard data={data} />;;
    }
  }

  const StatusIcon = () => {
    switch(trip_type.toLowerCase()) {
      case UPCOMING_KEY:
        return <StatusIconUpcoming />;
      case COMPLETED_KEY:
        return <StatusIconCompleted />;
      case CANCELLED_KEY:
        return <StatusIconCancelled />;
      case FAILED_KEY:
        return <StatusIconFailed />;
      default:
        return <StatusIconInProgress />;
    }
  }

  return(
    <S.TripInfoHeadOuterWrap>
      <StatusIcon />
      <HotelInfo />
      <S.TripInfoHeadViewBtnWrap onClick={() => {
        navigateToMyTripsDetails(`${payment_id}_${mobile}`);
      }}>
        <S.TripInfoViewBtn>VIEW & MANAGE BOOKING</S.TripInfoViewBtn>
      </S.TripInfoHeadViewBtnWrap>

    </S.TripInfoHeadOuterWrap>
  );
}

export default HotelCardInfoHead;
